module.exports = __webpack_public_path__ + "img/whitebookmark.cc2263a9.svg";